export default function Location() {
  return (
    <section className="py-20 bg-[#34495E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            ¿Dónde está nuestro bufete de laboralistas en Murcia?
          </h2>
          <div className="text-[#D4AF37] text-lg space-y-2">
            <p>
              <a 
                href="https://www.google.com/maps?cid=3023301393433464636" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:underline cursor-pointer"
              >
                C. San Lorenzo 6, 30001 Murcia
              </a>
            </p>
            <p>
              Teléfono: <a href="tel:968213493" className="hover:underline cursor-pointer">968 21 34 93</a>
            </p>
            <p>
              Mail: <a href="mailto:queredaymurciaabogados@gmail.com" className="hover:underline cursor-pointer">queredaymurciaabogados@gmail.com</a>
            </p>
          </div>
        </div>

        <div className="rounded-lg overflow-hidden shadow-2xl">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.6212402163733!2d-1.1309447379668751!3d37.98596764984827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd63832269dee675%3A0x29f4ec99648b8f3c!2sQuereda%20y%20Murcia%20Abogados%20Laboralistas!5e0!3m2!1ses!2ses!4v1686163592939!5m2!1ses!2ses"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación de Quereda y Murcia Abogados"
          ></iframe>
        </div>
      </div>
    </section>
  );
}